import * as angular from 'angular';
import { assign, take } from 'lodash';

import { themeData as themes } from './chart-theme-service/theme-data';

export default class ChartThemeService {
  public DEFAULT_THEME_ID = 'contrast';

  public DEFAULT_SIMPLE_THEME_ID = 'green';

  public getTheme(id: string) {
    if (!this.hasTheme(id)) {
      return themes.filter((theme) => theme.id === this.DEFAULT_THEME_ID)[0];
    }
    return themes.filter((theme) => theme.id === id)[0];
  }

  public getThemes(ids: Array<string>) {
    return themes.filter((theme) => !!~ids.indexOf(theme.id));
  }

  public getThemesAll() {
    return themes;
  }

  public hasTheme(id: string) {
    return themes.some((theme) => theme.id === id);
  }

  public getPalettes(ids: Array<string>) {
    const themePalette = (theme) => {
      const colorSummary = (color, i) => ({ [`color_${i}`]: color });
      const name = theme.name;
      const value = theme.id;
      const colors = take(theme.colors, 5).map(colorSummary).reduce(assign, {});

      return assign({ name, value }, colors);
    };

    return this.getThemes(ids).map(themePalette);
  }

  public getThumbPalette(id: string) {
    if (!this.hasTheme(id)) {
      return null;
    }
    const theme = this.getTheme(id);
    const colors = theme.colors;
    const thumbColors = theme.thumb_colors;

    return [colors[thumbColors[0]], colors[thumbColors[1]]];
  }
}
